import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { REHYDRATE } from 'redux-persist';

import { api } from '@services';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    signed: false,
    token: '',
    studioId: '',
    cookiePolicy: '',
    cookieKeyId: '',
    cookieSignature: '',
  },
  reducers: {
    signIn: (state, action) => {
      state.signed = true;
      state.token = action.payload.token;

      // Duplicate logic.
      api.defaults.headers.authorization = `Bearer ${action.payload.token}`;
    },
    updateCookiePolicy: (state, action: PayloadAction<string>) => {
      state.cookiePolicy = action.payload;
    },
    updateCookieKeyId: (state, action: PayloadAction<string>) => {
      state.cookieKeyId = action.payload;
    },
    updateCookieSignature: (state, action: PayloadAction<string>) => {
      state.cookieSignature = action.payload;
    },
    updateUserStudioId: (state, action: PayloadAction<string>) => {
      state.studioId = action.payload;
    },
    signOut: state => {
      state.signed = false;
      state.token = '';

      delete api.defaults.headers.authorization;
    },
  },
  extraReducers: builder => {
    builder.addCase(REHYDRATE, (_, action: any) => {
      if (action.payload?.auth?.signed) {
        // api.defaults.headers.authorization = `Bearer ${action.payload.auth.token}`;
      }
    });
  },
});

export const {
  // This isn't being used
  signIn,
  // This isn't being used
  signOut,
  updateCookiePolicy,
  updateCookieKeyId,
  updateCookieSignature,
  updateUserStudioId,
} = authSlice.actions;

export const { reducer: authReducer } = authSlice;
